<template>
  <FollowUpV7Playground />
</template>

<script>
import FollowUpV7Playground from '@/playground/follow-up/v7/index.vue';

/**
 * Dev scratch view for the /playground route. It only hosts a feature harness —
 * swap the imported component below to preview a different feature in isolation,
 * without deleting the existing one. Currently: the v7 follow-up modal harness
 * (src/playground/follow-up/v7/index.vue).
 */
export default {
  name: 'Playground',

  components: {
    FollowUpV7Playground,
  },
};
</script>
